import { MessagesService } from '@base/features/chat/messagesService';
import { IAuthService } from '@base/features/auth/model/interfaces';
import { Message } from '@base/features/chat/message';
import Color from '@base/features/game/model/color';
import { ITable } from '@base/features/game/model/interfaces';
import { AdditionalPlayerInfo } from '@base/features/game/model/types';
import { Subject, BehaviorSubject } from 'rxjs';
import GameService from '@base/features/game/model/gameService';
import { BasePreferences } from '@base/features/preferences/model/types';
import BaseTablesRepository from '@base/features/game/model/baseTableRepository';

export interface IPlayer {
  pid: number;
  name: string;
  rating: number;
  away: boolean;
  avatar: number;
  id?: number;
  country?: string;
  countryCode?: string;
  userId?: string;
  INVITE_MESSAGE_INTERVAL: number;
  tid: number;
  playerFilter: number;
  // rcLeft: number;
  avatarUrl(): string;
  setTable(table: ITable | undefined): void;
  getTable(): ITable | undefined;
  isMyTable(table: ITable | undefined): boolean;
  isPlayingTable(table: ITable): boolean;
  isAdmin(): number;
  isTD(): number;
  isBot(): number;
  isPhantom(): number;
  setMuted(muted: boolean): void;
  setIgnored(ignored: boolean): void;
  getStatus(): string;
  getRating(): number;
  isTicketPlayer(): number;
  getName(decorate?: boolean): string;
  getSeat(table: ITable | undefined): number;
  getPid(): number;
  getMoneyLimit(): number;
  getColor(): Color | undefined;
  getAdditionalInfo(): AdditionalPlayerInfo;
  isNotPlayer(table: ITable): boolean;
  isIgnored: () => boolean;
  checkInviteMessageInterval(tableId: number): boolean;
  isMuted: () => number;
  isPlayingTurn: () => boolean;
  addChatMessage(msg: Message): void;
  getChatMessages(): Message[];
  projectRating(matchResult: string, opponentRating: number): number;
}

export interface IPlayersOnlineRepository<
  P extends BasePreferences = BasePreferences,
  T extends ITable = ITable
> {
  me?: IPlayer;
  table?: BaseTablesRepository<T>;
  message?: MessagesService<P, T>;
  game?: GameService<P, T>;
  onInOutPlayer: Subject<LastInOutPlayer>;
  onPlayersListChanged: Subject<void>;
  accountBalance?: number;
  onPlayerLeft: Subject<any>;
  onLoginReady: BehaviorSubject<boolean>;
  authService?: IAuthService;

  sendFingerPid(pid: number): void;
  clear(): void;
  onPlayerJoined(data: IPlayer): void;
  findPlayer(players: IPlayer[], id: number): IPlayer | undefined;
  onPlayerAwayChanged(isAway: boolean): void;
  checkParams(params: any, options?: Record<string, unknown>): string | undefined;
  updatePlayerAvatar(avatar: Record<string, unknown>): void;
  addPlayer(player: IPlayer): void;
  getPlayersOnline(): Map<number, IPlayer>;
  getPlayerOnline(pid: number): IPlayer | undefined;
  addMessage(pid: number, message: Message): void;
}

export type LastInOutPlayer = {
  name: string;
  status: 'in' | 'out';
};

export enum PlayerStorageKeys {
  'GAMES_PLAYED' = 'games_played'
}
